import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiCollectionRepository, Result } from '@softline/core';
import { SOFTLINE_API_GESAMTAFRAGE_QUERY } from '../gesamtabfrage.api';
import { Beleg } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class BelegRepository extends ReadonlyHttpApiCollectionRepository<Result<Beleg[]>, Dictionary<unknown>> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GESAMTAFRAGE_QUERY);
  }

  protected override getLoadPayload(params: Dictionary<unknown>): unknown | undefined {
    return params;
  }
}
